export class ViewPublishedCircular{
    publishedCircularsId: number;
    userTypeId: number;
    userTypeName: string;
    userTypeNameEn: string;

}